import useMetaTag from "../../utilities/use-meta-tag";

import MastheadAlt from "../../components/masthead-alt/MastheadAlt";
import VimeoPlayer from "../../components/vimeo-player/VimeoPlayer";

export default function Overview() {
  useMetaTag({ name: "robots", content: "noindex, nofollow" });

  const videoUrl =
    "https://player.vimeo.com/video/1174628168?h=70288313eb&badge=0&autopause=0&player_id=0&app_id=58479";

  return (
    <div className="ua-recap ua-bg-primary-one ua-full-height">
      <header className="ua-recap--header">
        <MastheadAlt className="ua-recap--header--masthead" />
      </header>
      {videoUrl && (
        <div className="ua-recap--content sixteen-by-nine">
          <VimeoPlayer vimeoUrl={videoUrl} />
        </div>
      )}
    </div>
  );
}
